module.exports = __webpack_public_path__ + "img/zool.704d9461.png";